// extracted by mini-css-extract-plugin
module.exports = {"badge":"v+lc4","blue":"o-Zf4","red":"CLK8m","green":"uf3nP","orange":"_3IAWx","yellow":"kKYKK","black":"svupq"};